import React, { useState } from "react";
import { API_ROOT, apiJson } from "../shared";

function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("idle");
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!API_ROOT) {
      setErr("Contact form is not configured.");
      return;
    }

    const payload = {
      name: String(form.name || "").trim(),
      email: String(form.email || "").trim(),
      message: String(form.message || "").trim(),
    };

    if (!payload.email || !payload.message) {
      setErr("Please enter your email and a message.");
      return;
    }

    try {
      setStatus("sending");
      await apiJson(API_ROOT, "/contact/send", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      setStatus("sent");
      setForm({ name: "", email: "", message: "" });
    } catch (ex) {
      setStatus("idle");
      setErr(String(ex.message || ex));
    }
  };

  return (
    <section className="jh-container jh-section">
      <h1 className="jh-title">Contact Us</h1>
      <p className="jh-sub" style={{ maxWidth: 760, margin: "0 auto" }}>
        Need help with an order or have a question about a custom piece? Send us
        a message and we’ll get back to you.
      </p>

      <div style={{ maxWidth: 760, margin: "12px auto 0 auto" }}>
        <div>
          <div style={{ fontWeight: 700 }}>Email</div>
          <div className="jh-note" style={{ marginTop: 6 }}>
            support@ridleyjewelry.com
          </div>

          <div style={{ fontWeight: 700, marginTop: 12 }}>Hours</div>
          <div className="jh-note" style={{ marginTop: 6 }}>
            7am - 4pm PST • Monday - Friday
          </div>
        </div>

        <h2 className="jh-title" style={{ fontSize: 22, marginTop: 24 }}>
          Send a message
        </h2>

        {err ? (
          <div className="jh-note" style={{ marginTop: 10, color: "#b91c1c" }}>
            {err}
          </div>
        ) : null}

        {status === "sent" ? (
          <div className="jh-note" style={{ marginTop: 10 }}>
            Thanks! Your message has been sent.
          </div>
        ) : (
          <form
            className="jh-form-grid"
            onSubmit={onSubmit}
            style={{ marginTop: 10 }}
          >
            <div className="jh-field">
              <label className="jh-label">Name</label>
              <input
                className="jh-input wide"
                value={form.name}
                onChange={(e) =>
                  setForm((f) => ({ ...f, name: e.target.value }))
                }
              />
            </div>
            <div className="jh-field">
              <label className="jh-label">Email</label>
              <input
                className="jh-input wide"
                value={form.email}
                onChange={(e) =>
                  setForm((f) => ({ ...f, email: e.target.value }))
                }
              />
            </div>
            <div className="jh-field">
              <label className="jh-label">Message</label>
              <textarea
                className="jh-input wide"
                rows={6}
                value={form.message}
                onChange={(e) =>
                  setForm((f) => ({ ...f, message: e.target.value }))
                }
              />
            </div>
            <div className="jh-actions">
              <button className="jh-btn" type="submit">
                {status === "sending" ? "Sending..." : "Send"}
              </button>
            </div>
          </form>
        )}
      </div>
    </section>
  );
}

export default ContactPage;
